import * as React from 'react';
import styles from './ChartLoader.module.css';
import { Spinner } from '@watcherr/ui';

const ChartLoader = () => (
  <div className={styles.ChartLoader}>
    <Spinner label="Loading data..." />
  </div>
);
export default ChartLoader;
